<script>
  import Card from "../Card.svelte";

  export let job;

  // Keys and icons to display
  const MAP = {
    location: { icon: "far fa-location-pin", tooltip: "Location" },
    industries: { icon: "far fa-suitcase", tooltip: "Industries" },
    contractTypes: { icon: "far fa-file-pen", tooltip: "Contract Type" },
    salaryRange: { icon: "far fa-money-bill", tooltip: "Salary" },
    tags: { icon: "far fa-tag", tooltip: "Tags" },
  };

  $: status = job.isOpen ? "Open" : "Closed";
</script>

<Card item={job} {status} {MAP} />
